var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"box"},[_c('TableStats',{attrs:{"items":_vm.users,"columns":_vm.columnsUsers,"click_field":"licence_username"}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }